module.exports = __webpack_public_path__ + "img/22.b80bff66.jpg";